import CONFIG from './config-backend.js';
import { fetchAuth } from './fetchAuth.js';
import { showError } from './notify.js';

const getStatusBadgeClass = state => {
  switch (state) {
    case 'running': return 'state-running';
    case 'pending': return 'state-pending';
    case 'stopped': return 'state-stopped';
    default: return 'state-default';
  }
};

// Find the ECS service matching a crawler name (same logic as backend findServiceForCrawler)
const findServiceForCrawler = (services, crawlerName) => {
  const id = crawlerName.toLowerCase();
  const patterns = [
    n => n.toLowerCase() === `${id}_crawler`,
    n => n.toLowerCase() === id,
    n => n.toLowerCase().startsWith(`${id}_`),
    n => n.toLowerCase().includes(id),
  ];
  for (const pattern of patterns) {
    const match = services.find(s => pattern(s.name));
    if (match) return match;
  }
  return undefined;
};

document.addEventListener('DOMContentLoaded', async () => {
  document.getElementById('spinnerContainer').style.display = 'flex';

  let ecsServices = [];
  try {
    const response = await fetchAuth(`${CONFIG.BACKEND_URL}/crawler/ecs/services`, { method: 'GET' });
    const parsed = await response.json();
    if (Array.isArray(parsed)) ecsServices = parsed;
    else showError('Unexpected response from ECS services.');
  } catch {
    showError('Could not load ECS service status. Crawler states may be unavailable.');
  }

  fetchAuth(`${CONFIG.BACKEND_URL}/crawler`, { method: 'GET' })
    .then(response => {
      if (!response.ok) throw new Error(`Network response was not ok ${response.statusText}`);
      return response.json();
    })
    .then(data => {
      const tableBody = document.querySelector('#dataTable tbody');
      for (const item of data) {
        const ecsService = findServiceForCrawler(ecsServices, item.name);
        const state = ecsService ? ecsService.state : 'not found';
        const badgeClass = getStatusBadgeClass(state);

        const row = document.createElement('tr');
        row.style.cursor = 'pointer';
        row.addEventListener('click', () => {
          sessionStorage.setItem('crawlerMasterData', JSON.stringify(item));
          sessionStorage.setItem('crawlerContainerData', JSON.stringify(ecsService ?? { state: 'not found' }));
        });

        row.innerHTML = `
          <td>${item.id}</td>
          <td><span class="crawler-type type-${item.crawlerType ?? 'unknown'}">${item.crawlerType ?? '—'}</span></td>
          <td>${item.name}</td>
          <td><button class="btn btn-sm btn-soft-secondary" type="button" onclick=redirectToConfigPage("${item.id}")>Details</button></td>
          <td><button class="btn btn-sm btn-soft-info"      type="button" onclick=redirectToLogsPage("${item.id}")>Logs</button></td>
          <td><button class="btn btn-sm btn-soft-primary"   type="button" onclick=redirectToRUNSPage("${item.id}")>Runs</button></td>
          <td>${item.cronSettings}</td>
          <td><span class="status-dot ${badgeClass}">${state}</span></td>
        `;
        tableBody.append(row);
      }

      // eslint-disable-next-line no-undef
      $('#dataTable').DataTable({
        pageLength: 25,
        columnDefs: [{ orderable: false, targets: [3, 4, 5] }],
      });
    })
    .catch(() => showError('Could not load the crawlers list. Check your connection.'))
    .finally(() => {
      const spinner = document.getElementById('spinnerContainer');
      spinner.style.display = 'none';
      spinner.classList.remove('d-flex');
    });
});
